module.exports = {"130981001":"解放街道","130981002":"河东街道","130981003":"古楼街道","130981100":"泊镇","130981101":"交河镇","130981102":"齐桥镇","130981103":"寺门村镇","130981104":"郝村镇","130981105":"富镇镇","130981106":"文庙镇","130981107":"洼里王镇","130981201":"王武庄乡","130981202":"营子乡","130981203":"四营乡","130981204":"西辛店乡","130981400":"泊头市工业区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130981.json
// module id = 228
// module chunks = 0